export const PROJECTS_LIST = [
  {
    id: 'proj_1',
    icon: 'ri-shopping-cart-line',
    color: '#10b981',
    title: 'E-commerce',
    description: 'Поддержка клиентов онлайн-магазинов (вопросы по заказам, доставке, возвратам, ассортименту).',
  },
  {
    id: 'proj_2',
    icon: 'ri-code-s-slash-line',
    color: '#f59e0b',
    title: 'IT и SaaS',
    description: 'Помощь пользователям программных продуктов или облачных сервисов (технические вопросы, настройка, функционал).',
  },
  {
    id: 'proj_3',
    icon: 'ri-bank-line',
    color: '#8b5cf6',
    title: 'Финансовый сектор',
    description: 'Консультации по банковским продуктам, кредитам, инвестициям (после глубокого обучения и с соблюдением всех регуляций).',
  },
  {
    id: 'proj_4',
    icon: 'ri-customer-service-line',
    color: '#ef4444',
    title: 'Сфера услуг',
    description: 'Поддержка клиентов сервисов доставки, бронирования, образовательных платформ и т.д.',
  },
  {
    id: 'proj_5',
    icon: 'ri-wifi-line',
    color: '#06b6d4',
    title: 'Телекоммуникации',
    description: 'Консультации по тарифам, услугам связи, настройке оборудования.',
  },
];
